import type { ReactElement } from 'react';

/**
 * Форматирует ISO-дату в локализованную дату-время `ru-RU`. Общий хелпер
 * раздела «Жалобы на вакансии».
 */
export function formatDateTime(iso: string | null): string {
    if (iso === null) {
        return '—';
    }
    return new Date(iso).toLocaleString('ru-RU');
}

interface FieldProps {
    label: string;
    value: string | null;
    testId?: string;
    wide?: boolean;
    /** Сохранять переносы строк (free-text кафе/профи, plain-text — SF-14). */
    multiline?: boolean;
}

/**
 * Ячейка `dt/dd` в `Field`-сетке детали жалобы (эталон — `CafeApplicationDetailPage`).
 * Рендер строго как текстовое содержимое JSX (React экранирует) — без
 * `dangerouslySetInnerHTML` (SF-14).
 */
export function Field({ label, value, testId, wide, multiline }: FieldProps): ReactElement {
    return (
        <div className={wide ? 'sm:col-span-2' : undefined}>
            <dt className="text-xs font-medium uppercase text-gray-500">{label}</dt>
            <dd
                className={`text-gray-900${multiline ? ' whitespace-pre-wrap break-words' : ''}`}
                data-testid={testId}
            >
                {value !== null && value !== '' ? value : '—'}
            </dd>
        </div>
    );
}
